import { Modal, Col, Row } from "antd";
import React from "react";
import { Form } from "react-final-form";
import { useDispatch, useSelector } from "react-redux";

import { ContentLoader, FormField, FormFieldType } from "@components";
import { AppConfigActions, selectCountryRiskUpdating } from "@redux";
import { i18, trb, allowOnlyNumbers, checkMaxLength, numberFormat } from "@utilities";
import { RISK_TYPES } from "@config";

import "./EditRisk.less";

export const EditRisk = ({ onClose, riskConfig }) => {
  const dispatch = useDispatch();
  const isLoading = useSelector(selectCountryRiskUpdating);

  const onSubmit = async data => {
    try {
      await dispatch(AppConfigActions.updateRiskItem(data));
      onClose();
    } catch {}
  };

  return (
    <Form
      onSubmit={onSubmit}
      initialValues={riskConfig}
      mutators={{
        setScoreAfterBlur: (_args, state, utils) => {
          const lastScore = Number(state.lastFormState.values.riskScore);
          if (lastScore > 100) {
            utils.changeValue(state, "riskScore", () => 100);
          }
          if (lastScore < 0 || !lastScore) {
            utils.changeValue(state, "riskScore", () => 0);
          }
        }
      }}
      render={({ handleSubmit, form }) => {
        return (
          <Modal
            visible
            width={800}
            onOk={handleSubmit}
            onCancel={onClose}
            cancelText={trb(i18.Buttons.Cancel)}
            okText={trb(i18.Buttons.Ok)}
            okButtonProps={{ loading: isLoading }}
            cancelButtonProps={{ disabled: isLoading }}
          >
            <form className="my-4 edit-risk-config-form" onSubmit={handleSubmit}>
              {isLoading && <ContentLoader />}
              {!isLoading && (
                <>
                  <Row gutter={[16, 0]}>
                    <Col xs={24}>
                      <FormField
                        name="riskDescription"
                        component={FormFieldType.textarea}
                        title={trb(i18.ApplicationsLabels.RiskDescription)}
                        size="large"
                        className="mb-4"
                        maxLength={500}
                        validate={checkMaxLength(500)}
                        componentOptions={{ className: "no-resize risk-description-textarea" }}
                      />
                    </Col>

                    <Col xs={24} sm={12}>
                      <FormField
                        name="riskScore"
                        component={FormFieldType.number}
                        onKeyDown={allowOnlyNumbers}
                        title={trb(i18.ApplicationsLabels.RiskScore)}
                        size="large"
                        formatNumber={numberFormat().number}
                        onBlur={form.mutators.setScoreAfterBlur}
                        className="mb-4"
                      />
                    </Col>

                    <Col xs={24} sm={12}>
                      <FormField
                        name="riskType"
                        component={FormFieldType.select}
                        title={trb(i18.ApplicationsLabels.riskTypeLabel)}
                        optionsLabel="label"
                        optionsValue="value"
                        options={Object.values(RISK_TYPES).map(item => ({
                          value: item,
                          label: trb(i18.ApplicationsLabels[item])
                        }))}
                        size="large"
                        className="mb-4"
                      />
                    </Col>

                    <Col xs={24} sm={12}>
                      <FormField
                        name="isActive"
                        component={FormFieldType.checkbox}
                        label={trb(i18.ApplicationsLabels.riskIsActiveLabel)}
                        inline={true}
                        size="large"
                        className="mb-4"
                      />
                    </Col>
                    <Col xs={24} sm={12}>
                      <FormField
                        name="isAutomatic"
                        component={FormFieldType.checkbox}
                        label={trb(i18.ApplicationsLabels.riskIsAutomaticLabel)}
                        inline={true}
                        size="large"
                        className="mb-4"
                      />
                    </Col>
                  </Row>
                </>
              )}
            </form>
          </Modal>
        );
      }}
    />
  );
};
